<template>
    <div>
        <el-card>
            <div class="detail-body" >
                <iframe
                        :src="iframeUrl"
                        frameborder="0"
                        id="bdIframes"
                        ref="iframe"
                ></iframe>
            </div>
        </el-card>
    </div>
</template>

<script>
    let _this = null;
    export default {
        name: 'jupyterhub',
        data() {
            return {
                activeName: '',
                iframeUrl: 'https://hpc.linc.org.cn:62091/',
                loading: false
            }
        },
        created() {
            _this = this;
        },
        mounted() {
            _this = this;
            _this.getData();
        },
        methods: {
            getData() {
                _this.loading = true
                const oIframe = document.getElementById('bdIframes');
                const deviceHeight = document.documentElement.clientHeight;
                oIframe.style.height = (Number(deviceHeight) - 130) + 'px';
            },
            handleClick() {
                this.getData()
            },
        },
    };
</script>
<style scoped>
    .detail-body {
        width: 100%;
        /*height: 100vh;*/
        position: relative;
    }

    iframe {
        width: 100%;
        height: 100%;
        /*border: none;*/
    }
</style>